export default "<div>\n\t<div id=\"map\"></div>\n</div>";